angular.module('content.widgets.asfAddons', [
  'schemaForm'
])
.config([
  'schemaFormDecoratorsProvider',
  '$uibTooltipProvider',
  function (schemaFormDecoratorsProvider, $uibTooltipProvider) {
    'use strict';

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'collapsible',
        'content/source/content/widgets/schemaFormAddons/collapsible.html'
    );

    schemaFormDecoratorsProvider.addMapping(
      'bootstrapDecorator',
      'horizontal-checkbox',
      'content/source/content/widgets/schemaFormAddons/horizontal-checkbox.html'
    );

    schemaFormDecoratorsProvider.addMapping(
      'bootstrapDecorator',
      'horizontal-text',
      'content/source/content/widgets/schemaFormAddons/horizontal-text.html'
    );

    schemaFormDecoratorsProvider.addMapping(
      'bootstrapDecorator',
      'horizontal-select',
      'content/source/content/widgets/schemaFormAddons/horizontal-select.html'
    );

    schemaFormDecoratorsProvider.addMapping(
      'bootstrapDecorator',
      'horizontal-array',
      'content/source/content/widgets/schemaFormAddons/horizontal-array.html'
    );

    schemaFormDecoratorsProvider.addMapping(
      'bootstrapDecorator',
      'horizontal-textarea',
      'content/source/content/widgets/schemaFormAddons/horizontal-textarea.html'
    );

    $uibTooltipProvider.setTriggers({ open: 'close' });
  }
])
.directive('popoverToggle', [
  '$timeout',
  function ($timeout) {
    'use strict';

    return {
      scope: true,
      link: function (scope, element) {
        scope.toggle = function () {
          $timeout(function () {
            element.triggerHandler(scope.openned ? 'close' : 'open');
            scope.openned = !scope.openned;
          });
        };
        return element.on('click', scope.toggle);
      }
    };
  }]);
